module.exports = __webpack_public_path__ + "static/media/SHSProdIcons_Keyboard.7ad1192b.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/homepage/resources/SHSProdIcons_Keyboard.svg
// module id = 1619
// module chunks = 0